<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs10>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
          </v-btn>
        </v-flex>
                
        <v-flex xs2>
            <report-list-actions
            :reportOptions="reportOptions"
            :downloadFilename="reportListFilename"
            ></report-list-actions>
        </v-flex>

        <v-row>
          <v-col cols="12">
            <h3 class="text-center mb-5">Medication Review Result</h3>
          </v-col>
        </v-row>
      </v-layout>

      <v-divider class="ml-4 mr-4 mb-3"></v-divider>

      <v-row>
        <v-col cols="12">
          <v-card class="ma-3 pa-3" elevation="0">
            <v-row>
              <v-col cols="12" md="4" class="pa-1">
                <v-menu
                  ref="calendarMenu"
                  v-model="calendarMenu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.startDate"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="requiredField"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.startDate"
                    no-title
                    scrollable
                    :rules="requiredField"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="calendarMenu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.calendarMenu.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="4" class="pa-1">
                <v-menu
                  ref="calendar2Menu"
                  v-model="calendar2Menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="requiredField"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.endDate"
                    no-title
                    scrollable
                    :rules="requiredField"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="calendar2Menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.calendar2Menu.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="4" class="pa-1 mb-2">
                <v-combobox
                  label="Select a Staff"
                  :items="staffs"
                  item-text="Name"
                  item-value="_id"
                  v-model="filters.staff"
                  clearable
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="3" class="pa-1 mb-2">
                <v-combobox
                  label="Select a Program"
                  :items="programs"
                  item-text="Name"
                  item-value="_id"
                  v-model="filters.program"
                  clearable
                  @change="onSelectProgram"
                ></v-combobox>
              </v-col>

              <v-flex cols="12" md="3"  class="pa-1 mb-2">
                  <v-select
                    label="Client Status"
                    :items="clientStatuses"
                    v-model="filters.clientStatus"
                    clearable
                    ></v-select>
                </v-flex>

              <v-col cols="12" md="3" class="pa-1 mb-2">
                <v-combobox
                  label="Select a Client"
                  :items="filteredClients"
                  item-text="Name"
                  item-value="_id"
                  v-model="filters.client"
                  clearable
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="3" class="pl-5">
                <v-btn @click="getMARs()">Search</v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pa-2">
                <v-data-table
                  :headers="headers"
                  :items="mars"
                  sort-by="Name"
                  sort-desc
                  class="elevation-1"
                  :loading="isLoading"
                  loading-text="Loading MAR"
                  :server-items-length="itemCount"
                  @pagination="getMARs"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      x-small
                      class="white--text"
                      color="#2b3990"
                      @click="viewMAR(item)"
                    >
                      View
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <div id="print">
      <report-header>
        <h2>Medication Review Result</h2>
      </report-header>
      <v-row>
          <v-col cols="12">
              <v-data-table
                  :headers="headers"
                  :items="mars"
                  sort-by="Date"
                  sort-desc
                  class="elevation-1"
                  :loading="isLoading"
                  loading-text="Loading Medication Review Result"
                  :items-per-page="-1"
                  :options.sync="options"
              >
                  <template v-slot:item.select="{ item }">

                      <v-btn
                          x-small
                          class="white--text"
                          color="#2b3990"
                          @click="viewCertification(item)"
                      >
                          View
                      </v-btn>

                  </template>
              </v-data-table>
          </v-col>
      </v-row>
  </div>

    <MarSignDialog
      ref="marDialog"
      :dialog="dialog"
      @close="dialog = false"
      :isShowUpdateBtn="false"
    />
  </div>
</template>
<script>
import axios from "axios";
import momentTz from "moment-timezone";
import moment from "moment";
import MarSignDialog from "@/components/medications/MAR/MarSignDialog";
import ReportHeader from '@/components/Report/ReportHeader.vue';
import ReportListActions from '@/components/Report/ReportListActions.vue';
import { STATUS_ARRAY } from '../../enums/UserStatusEnum';

const url = require("../../client_config/config").url;

export default {
  components: {
    MarSignDialog,
    ReportHeader,
    ReportListActions
  },
  data: () => ({
    headers: [
      {
        text: "Date",
        align: "start",
        sortable: true,
        value: "Date",
      },
      { text: "Client", value: "client.Name" },
      { text: "Program", value: "client.Program" },
      { text: "Medication", value: "medication.name" },
      { text: "Exception", value: "Exception" },
      { text: "PRN Note", value: "FollowUpPRN.Note" },
      { text: "Notes", value: "Notes" },
      { text: "Admin Time", value: "AdminTime" },
      { text: "Signature", value: "Signature" },
      { text: "Verified By", value: "VerifiedBy" },
      { text: "Actions", value: "actions" },
    ],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    clients: [],
    mars: [],
    startDate: "",
    endDate: "",
    client: "",
    staff: "",
    program: "",
    calendarMenu: false,
    calendar2Menu: false,
    isLoading: false,
    requiredField: [(v) => !!v || "This is required"],
    userState: localStorage.getItem("userState"),
    msg: false,
    text: "",
    color: "",
    actualTime: "",
    paginationInfo: {},
    itemCount: 0,
    staffs: [],
    programs: [],
    programName: "",
    dialog: false,
    isDownloading: false,
    clientState: "",
    page: 1,
    pageCount: 1,
    options: {},
    clientStatus: "",
    clientStatuses: STATUS_ARRAY,
    filters: {
      clientStatus: '',
      startDate: '',
      endDate: '',
      programName: '',
      staff: '',
      client: '',
    }
  }),

  computed: {
    filteredClients() {
      let clients = this.clients;

      if (this?.programName != "") {
        clients = this.clients.filter((client) =>
          client.Program.includes(this.programName)
        );
      }

      if (this?.clientStatus != "" && this.clientStatus) {
        clients = clients.filter((client) => client.Status == this.clientStatus)
      }

      return clients;
    },
    queryParams() {
            let {page, sortBy, sortDesc, itemsPerPage} = this.options;

            let numItems = itemsPerPage || 10;
            
            const sortField = sortBy ? sortBy[0] : 'Date';
            const sortDirection = sortDesc ? sortDesc[0] : 'desc';

            return {
              startDate: this.filters.startDate || null,
              endDate: this.filters.endDate || null,
              clientId: this.filters.client?._id || null,
              staff: { _id: this.filters.staff?._id, Name: this.filters.staff?.Name } || null,
              program: this.filters.programName || [],
              tz: momentTz.tz.guess(),
              page: page || 1,
              limit: numItems || 10,
              clientStatus: this.filters.clientStatus,
              state: this.userState,
              sortField: sortField,
              sortDirection: sortDirection,
            };
        },

        reportOptions() {
            let query = {
                name: this.staffName,
            }

            Object.assign(query, this.queryParams);

            return { 
                query: query,
                endpoints: `MAR/medication-report/printList`,
                dynamic: true
            }
        },
        reportListFilename() {
            return `Medication Review Result`
        }
  },

  created() {
    this.initialize();
    this.getClients();
    this.getStaffs();
    this.getPrograms();
    this.getFilters();
  },
  

  watch: {
      filters: {
          handler() {
              this.setFilters();
          },
          deep: true
      }
    },

  methods: {
    initialize() {
      this.clients = [];
      this.staffs = [];
      this.programs = [];
    },

    async getClients() {
      let params = {};
      let endpoint = `${url}/clients`;

      const companyIds = localStorage.getItem("userCompanies");

      params["Company:in"] = JSON.parse(companyIds);
      params["State"] = this.userState;

      await axios.get(endpoint, { params }).then((res) => {
        this.clients = res.data.clients;
      });
    },

    getStaffs() {
      axios.get(`${url}/users/getAll/users/${this.userState}`).then((res) => {
        this.staffs = res.data.users;
      });
    },

    async getPrograms() {
      await axios.get(`${url}/units/state/${this.userState}`).then((res) => {
        this.programs = res.data.units;
      });
    },

    async getMARs(item = {page: 1, itemsPerPage: 10}) {
      this.paginationInfo = item;

      const params = this.queryParams;

      let endpoint = `${url}/MAR/medication-report`;

      this.isLoading = true;

      axios
        .get(endpoint, { params })
        .then((response) => {
          const { docs, totalPages, totalDocs } = response.data;
          this.mars = docs.map((item) => {
            item.Date = moment(item.Date)
              .tz("America/Denver")
              .format("MM/DD/YYYY");
            return item;
          });

          this.pageCount = totalPages;
          this.itemCount = totalDocs;

        })
        .finally(() => (this.isLoading = false));
    },

    viewMAR(item) {
      this.$refs.marDialog.onViewItem(item);
      this.dialog = true;
    },

    onSelectProgram(e) {
      this.programName = e?.Name || "";
      this.filters.programName = this.programName;
    },

    printTable() {
        this.getMARs();
        window.print()
    },

    getFilters() {
        let filters = localStorage.getItem('medicationResultReportFilter');
        if (filters) {
            this.filters = JSON.parse(filters);
        }
    },

    setFilters() {
        localStorage.setItem('medicationResultReportFilter', JSON.stringify(this.filters));
    }
  },
};
</script>
<style>
#print {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }

  body {
    margin: 1.6cm;
  }
}
</style>
9